import { Button } from '@client/toolkit';
import { FaRegFileExcel, FaRegFilePdf } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export const ExportButtons = ({ onExportExcel, loading }: { onExportExcel?: () => void; loading?: boolean }) => {
  const { t: tGlobal } = useTranslation('global');

  return (
    <div className="flex gap-2">
      {/*<Button
        size="sm"
        color="primary-light"
        className="text-white font-normal"
        startIcon={<FaRegFilePdf className="text-brand-primary" />}
        disabled={true}
      >
        {tGlobal('exportPdf')}
      </Button>*/}
      <Button
        size="sm"
        color="primary-light"
        className="text-white font-normal"
        startIcon={<FaRegFileExcel className="text-brand-primary" />}
        onClick={onExportExcel}
        loading={loading}
      >
        {tGlobal('exportExcel')}
      </Button>
    </div>
  );
};
